import {Component} from '@packages/systems/wfdl';
import {type NativeId} from '@packages/systems/core/utils/NativeIdUtils';
import type {NodeHoveredPayload} from './types';

import {mem_transformDesignerPayload} from '../shared/transformPayload';

export const transformNodeHoveredPayload = (
  payload: NodeHoveredPayload,
  components: Component.ComponentMap,
  focusedSymbolNativeIdPath: NativeId[]
): NodeHoveredPayload => {
  return mem_transformDesignerPayload<NodeHoveredPayload>(payload)(components)(
    focusedSymbolNativeIdPath
  );
};
